export type BrowserStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export const createSafeBrowserStorage = (
    getStorage: () => BrowserStorage | null,
): BrowserStorage => ({
    getItem: (key) => {
        try {
            return getStorage()?.getItem(key) ?? null;
        } catch {
            return null;
        }
    },
    setItem: (key, value) => {
        try {
            getStorage()?.setItem(key, value);
        } catch {
            // Storage is optional in restricted browser contexts.
        }
    },
    removeItem: (key) => {
        try {
            getStorage()?.removeItem(key);
        } catch {
            // Storage is optional in restricted browser contexts.
        }
    },
});

export const safeSessionStorage = createSafeBrowserStorage(() => {
    if (typeof globalThis.sessionStorage === 'undefined') {
        return null;
    }
    return globalThis.sessionStorage;
});

export const safeLocalStorage = createSafeBrowserStorage(() => {
    if (typeof globalThis.localStorage === 'undefined') {
        return null;
    }
    return globalThis.localStorage;
});
